import React from 'react';

const IconFlashOn = (): React.ReactElement => (
    <i id="iconFlashOn" className="material-symbols-outlined">
        flash_on
    </i>
);

export default IconFlashOn;
